<template>
  <span v-if="count" class="p-text-label-new-arrival-count">
    <span
      class="p-text-label-new-arrival-count__body"
      :style="{ backgroundColor: colorCode }"
    >
      <span class="p-text-label-new-arrival-count__text">{{ count }}</span>
    </span>
  </span>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import commons from "@/common/store/modules/commons";

@Options({
  props: {
    count: {
      type: [String, Number, Boolean],
      required: true,
      default: false
    }
  },
  computed: {
    storeColorCode() {
      return commons.colorCode;
    }
  }
})
export default class TextLabelNewArrivalCount extends Vue {
  count!: any;
  storeColorCode: string;

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode
  }

  get colorCode() {
    if(this.isGroupBudget) {
      return '#fc9014'
    }
    return this.storeColorCode
  }

}
</script>

<style lang="scss" scoped>
.p-text-label-new-arrival-count {
  width: rem(16);
  height: rem(16);
  display: block;

  &__body {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 100%;
    height: 100%;
  }

  &__text {
    font-size: rem(10);
    color: $common-white;
    font-weight: bold;
    line-height: 1;
  }
}
</style>
